import * as Action from "../action/ops_overview.action"

const initState = {
    customUnitInfo: {
        id: "",
    },
}

/**
 * 概览reducer
 */
const overViewReducer = (state = initState, action) => {
    switch (action.type) {
        case Action.OVERVIEW_SET_CUSTOM_UNIT_INFO: // 设置用电单位概览信息
        default: return {...state}
    }
}

export default overViewReducer;
